import { API_ROUTES } from "../../../constants/apiRoutes";
import apiClient from "../../../services/api/apiClient";
import { useState } from 'react';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register plugin globally for Chart.js usage
Chart.register(ChartDataLabels);


export class ModalMetricsManager {

    getModalElement(deviceName = null) {
        const resolvedDeviceName = deviceName || this._deviceName
        return document.getElementById('deviceMetrics-' + resolvedDeviceName)
    }

    showModalMetrics() {
        const modal = this.getModalElement()
        if (!modal) {
            return
        }
        modal.classList.remove('show')
        let deviceLabel = this._deviceLabel
        if (!deviceLabel) {
            deviceLabel = this._deviceName.replace('R_', '')
        }
        this.destroyCharts()

        const metrics7d = modal.querySelector('#divMetrics7d')
        if (metrics7d) {
            metrics7d.classList.add('d-none')
        }
        const showButton = modal.querySelector('#btnShowMetrics7d')
        if (showButton) {
            showButton.classList.remove('d-none')
        }

        const title = modal.querySelector('.modal-header h4')
        if (title) {
            title.textContent = 'Métriques pour ' + deviceLabel
        }
        this._buildCanvasMetrics('24h', this._deviceName)
        modal.classList.add('show')
        modal.classList.add('d-block')
    }

    closeModalMetrics() {
        const modal = this.getModalElement()
        if (!modal) {
            return
        }
        modal.classList.remove('show')
        modal.classList.remove('d-block')
        this.destroyCharts()
        this._onModalClose()
    }

    showMetrics7d() {
        const modal = this.getModalElement()
        if (!modal) {
            return
        }
        let deviceLabel = this._deviceLabel
        if (!deviceLabel) {
            deviceLabel = this._deviceName.replace('R_', '')
        }

        const metrics7d = modal.querySelector('#divMetrics7d')
        if (metrics7d) {
            metrics7d.classList.remove('d-none')
        }
        const showButton = modal.querySelector('#btnShowMetrics7d')
        if (showButton) {
            showButton.classList.add('d-none')
        }
        this.canvasCharts['canvasMetrics7d'] ? this.canvasCharts['canvasMetrics7d'].destroy() : null

        this._buildCanvasMetrics('7d', this._deviceName)
    }

    _buildCanvasMetrics(deviceMetricDataGroup, deviceName) {
        const modal = this.getModalElement(deviceName)
        if (!modal) {
            return
        }
        if (deviceMetricDataGroup === '7d') {
            const metrics7d = modal.querySelector('#divMetrics7d')
            if (metrics7d) {
                metrics7d.classList.remove('d-none')
            }
        }
        apiClient.get(API_ROUTES.DEVICES_METRICS, {
            params: {
                deviceName: deviceName,
                groups: [deviceMetricDataGroup]
            }
        }).then((deviceMetrics) => {
            let dataLabels = null, dataPoints = [], chartLabels = [];
            const currentDeviceMetrics = deviceMetrics[deviceMetricDataGroup]
            Object.keys(currentDeviceMetrics).forEach((metricName) => {
                let currentDataLabels = [], currentDataPoints = []
                Object.keys(currentDeviceMetrics[metricName]).forEach((datetime) => {
                    const xLabel = deviceMetricDataGroup === '24h' ? datetime.substr(-5) : datetime.substr(-11)
                    currentDataLabels.push(xLabel)
                    currentDeviceMetrics[metricName][datetime] < 1 && !this._displayZeroValues ? currentDataPoints.push(null) : currentDataPoints.push(currentDeviceMetrics[metricName][datetime])
                })
                if (!dataLabels) {
                    dataLabels = currentDataLabels
                }
                dataPoints.push(currentDataPoints)
                chartLabels.push(metricName)
            })
            const canvasElement = modal.querySelector('.canvasMetrics' + deviceMetricDataGroup)
            this._buildChart('line', canvasElement, dataLabels, dataPoints, true, chartLabels)

            setTimeout(() => {
                if (canvasElement && canvasElement.parentElement && canvasElement.parentElement.parentElement) {
                    canvasElement.parentElement.parentElement.scrollLeft = 10000
                }
            }, 500)
        })
    }


    _buildChart(chartType, canvasElement, dataLabels, dataPoints, useDataLabels = true, labels = null) {
        if (!canvasElement) {
            return
        }

        const options = { backgroundColor: '#2865a7' }
        let plugins = []
        if (useDataLabels === true) {
            options.plugins = {
                datalabels: {
                    color: 'black',
                    align: 'end',
                    anchor: 'end',
                    font: { weight: 'bold' },
                }
            }
            plugins = [ChartDataLabels]
        }
        options.pointBorderWidth = 6
        options.pointHoverBorderWidth = 12

        const backgroundColors = ['#2865a7', '#9b9338']
        let dataSets = []

        dataPoints.forEach((item, index) => {
            let dataLabelsCurrentData = {
                align: 'end',
                anchor: 'end',
                color: '#2865a7',
                offset: 5
            }
            if (index % 2 !== 0) {
                dataLabelsCurrentData = {
                    align: chartType === 'line' ? 'start' : 'end',
                    anchor: chartType === 'line' ? 'start' : 'end',
                    color: '#9b9338',
                    offset: 5
                }
            }
            dataSets.push({
                backgroundColor: backgroundColors[index],
                label: labels[index],
                data: dataPoints[index],
                borderColor: backgroundColors[index],
                fill: false,
                datalabels: dataLabelsCurrentData
            })
        })
        const canvasKey = canvasElement.className || canvasElement.id
        this.canvasCharts[canvasKey] ? this.canvasCharts[canvasKey].destroy() : null

        let barChart = new Chart(canvasElement, {
            type: chartType,
            plugins: plugins,
            data: {
                labels: dataLabels,
                datasets: dataSets,
            },
            options: options
        })
        this.canvasCharts[canvasKey] = barChart
        this._setCanvas(this.canvasCharts)
    }

    destroyCharts() {
        if (this.canvasCharts) {
            this.canvasCharts['canvasMetrics24h'] ? this.canvasCharts['canvasMetrics24h'].destroy() : null
            this.canvasCharts['canvasMetrics7d'] ? this.canvasCharts['canvasMetrics7d'].destroy() : null
        }
    }

}



export default function HousePilotModalMetrics({ deviceName, deviceLabel, showModal, onModalClose, displayZeroValues = false }) {

    const manager = new ModalMetricsManager()
    manager._deviceName = deviceName
    manager._deviceLabel = deviceLabel
    manager._onModalClose = onModalClose
    manager._displayZeroValues = displayZeroValues
    
    const stateCanvas = useState([])
    manager.canvasCharts = stateCanvas[0]
    manager._setCanvas = stateCanvas[1]

    if (showModal === true) {
        manager.showModalMetrics()
    }

    return (
        <>
            <div className="modal fade" id={"deviceMetrics-" + deviceName} role="dialog" aria-hidden="true" style={{ zIndex: "2" }}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header d-block text-center">
                            <h4></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => manager.closeModalMetrics()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <h5>Dernières 24H</h5>
                            <div className="mb-5" style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
                                <div style={{ width: "4000px", height: "300px" }} className='canvasContainer'>
                                    <canvas className="canvasMetrics24h" id={"canvas24H-" + deviceName} width="0" height="300"></canvas>
                                </div>
                            </div>
                            <h5>Derniers 7 Jours</h5>
                            <button type="button" className="btn btn-secondary" onClick={() => { manager.showMetrics7d() }} id="btnShowMetrics7d"> Afficher les stats sur 7 jours</button>
                            <div className="mb-5 d-none" style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }} id="divMetrics7d">
                                <div style={{ width: "4000px", height: "300px" }} className='canvasContainer'>
                                    <canvas className="canvasMetrics7d" id={"canvas7D-" + deviceName} width="0" height="300"></canvas>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer text-center mx-auto">
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => manager.closeModalMetrics()}>Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
